import styled from 'styled-components/macro'

export const Wrap = styled.footer`
  background: ${({ theme }) => theme.color.background};
  border-top: 1px solid ${({ theme }) => theme.color.miscLighter};
  text-align: center;
  padding: 18px 0;
`
